import { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../cartContext';
import { useSearch } from '../searchContext';
import { useAccount } from '../accountContext';
import { storefrontLinks } from '../navLinks';
import { FREE_SHIPPING_MINIMUM } from '../shipping';

const SearchIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M16 16l5 5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const UserIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="8" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M5 19c1.5-3.2 4-4.8 7-4.8S17.5 15.8 19 19" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const NavBar = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const onArt = pathname.startsWith('/portfolio');
    const { cartCount, setCartOpen } = useCart();
    const { open: searchOpen, setOpen: setSearchOpen } = useSearch();
    const { user } = useAccount();

    useEffect(() => {
        setMenuOpen(false);
    }, [pathname]);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 6);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header className={['siteChrome', scrolled ? 'siteChromeScrolled' : '', onArt ? 'siteChromeArt' : ''].filter(Boolean).join(' ')}>
            <div className="announcementBar">
                {`free shipping on U.S. orders over $${FREE_SHIPPING_MINIMUM}`}
            </div>
            <nav className="topNav" key={pathname}>
                <div className="navLeft">
                    <button className="navLogo" onClick={() => navigate('/')} aria-label="Home">
                        <img className="navLogoMark" src="/images/logo.png" alt="Logo" />
                    </button>

                    <div className={menuOpen ? 'navLinks navLinksOpen' : 'navLinks'}>
                        {storefrontLinks.map((link) => (
                            <NavLink
                                key={link.to}
                                to={link.to}
                                className={({ isActive }) => (isActive ? 'navLink navLinkActive' : 'navLink')}
                                onClick={() => setMenuOpen(false)}
                                end={link.to === '/'}
                                aria-label={link.label}
                            >
                                <img className="navLinkMark" src={link.src} alt="" />
                            </NavLink>
                        ))}
                    </div>
                </div>

                <div className="navIcons">
                    <button
                        className={searchOpen ? 'navIconButton navIconButtonActive' : 'navIconButton'}
                        aria-label="Search"
                        aria-expanded={searchOpen}
                        onClick={() => {
                            setMenuOpen(false);
                            setSearchOpen((open) => !open);
                        }}
                    >
                        <SearchIcon />
                    </button>
                    <button
                        className={user ? 'navIconButton navIconButtonActive' : 'navIconButton'}
                        aria-label={user ? 'Account' : 'Sign in'}
                        onClick={() => {
                            setSearchOpen(false);
                            navigate('/account');
                        }}
                    >
                        <UserIcon />
                    </button>
                    <button className="navIconButton navBagButton" aria-label={`Bag ${cartCount}`} onClick={() => setCartOpen(true)}>
                        <span>Bag</span> <span className="navBagCount">{cartCount}</span>
                    </button>
                    <button
                        className="navMenuToggle"
                        aria-label="Menu"
                        aria-expanded={menuOpen}
                        onClick={() => setMenuOpen((open) => !open)}
                    >
                        {menuOpen ? 'close' : 'menu'}
                    </button>
                </div>
            </nav>
        </header>
    );
};

export default NavBar;
